import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CustomerQuickUrlContentAnalysisService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customerquickurlcontentanalysis`;

  constructor(private http: HttpClient) { }

  process(websiteUrlId: number): Observable<Boo.Objects.QuickUrlContentAnalysis> {
    return this.http.post<Boo.Objects.QuickUrlContentAnalysis>(`${this.baseUrl}/Process`, websiteUrlId);
  }
}
